if (!customElements.get("product-modal")) {
	customElements.define(
		"product-modal",
		class ProductModal extends ModalDialog {
			constructor() {
				super()
			}

			hide() {
				super.hide()
				this.gallery.destroy()
				const existingUl = document.querySelectorAll(
					".js-swiper-wrapper-modal"
				)

				const spinner = document.querySelector(
					".js-loading-overlay-spinner"
				)
				spinner.classList.remove("hidden")
				const elementsToRemove = []

				existingUl.forEach((list) => {
					const existingElements = list.querySelectorAll("li")
					existingElements.forEach((liElement) => {
						if (
							!liElement.classList.contains("js-media__product")
						) {
							elementsToRemove.push(liElement)
						}
					})
				})

				elementsToRemove.forEach((liElement) => {
					liElement.parentNode.removeChild(liElement)
				})
			}

			show(opener) {
				super.show(opener)
				//this.showActiveMedia()
				this.showContent(opener)
			}

			showContent(opener) {
				const featuredImages = document.querySelectorAll(
					".js-featured-image-row"
				)

				let activeImageIndex
				let activeIndex = opener.getAttribute("data-index")

				featuredImages.forEach((featuredImage, index) => {
					const dataFile = featuredImage.getAttribute("data-file")
					if (dataFile == activeIndex) {
						activeImageIndex = index
					}
				})

				const modal_id = opener.getAttribute("data-id")

				//console.log(activeImageIndex, activeIndex, modal_id)

				const existingUl = document.querySelector(
					"#" + modal_id + " .js-swiper-wrapper-modal"
				)
				const spinner = document.querySelector(
					"#" + modal_id + " .js-loading-overlay-spinner"
				)

				const fragment = document.createDocumentFragment()

				featuredImages.forEach((featuredImage, index) => {
					const liElement = document.createElement("li")
					liElement.classList.add("grid__item", "swiper-slide")
					const dataFile = featuredImage.getAttribute("data-file")
					const imageClone = new Image()

					imageClone.src = featuredImage.src
					imageClone.setAttribute("data-file", dataFile)

					if (dataFile == activeIndex) {
						activeImageIndex = index
					}

					liElement.appendChild(imageClone)
					fragment.appendChild(liElement)
				})

				if (existingUl) {
					const firstLi = existingUl.querySelector("li:first-child")
					if (firstLi) {
						existingUl.insertBefore(fragment, firstLi.nextSibling)
					} else {
						existingUl.appendChild(fragment)
					}
				}

				setTimeout(() => {
					const swiperNext = document.querySelector(
						"#" + modal_id + " .js-swiper-modal .js-button-next"
					)
					const swiperPrev = document.querySelector(
						"#" + modal_id + " .js-swiper-modal .js-button-prev"
					)

					this.gallery = new Swiper(
						"#" + modal_id + " .js-swiper-modal",
						{
							speed: 400,
							loop: false,
							//loopedSlides: 50,
							spaceBetween: 24,
							slidesPerView: 1,
							navigation: {
								nextEl: swiperNext,
								prevEl: swiperPrev,
							},
							keyboard: {
								enabled: true,
								onlyInViewport: false
							},

						}
					)
					console.log(activeImageIndex)
					if (activeImageIndex) {
						setTimeout(() => {
							this.gallery.slideToLoop(activeImageIndex, 0, false)
						}, 100)
					}
					setTimeout(() => {
						if (spinner) {
							spinner.classList.add("hidden")
						}

						let idleTimer
						let idleState = false

						function showFoo(time) {
							clearTimeout(idleTimer)
							if (idleState === true) {
								const fooElement = document.querySelector(
									"#" +
										modal_id +
										" .product-media-modal__content"
								)
								fooElement.classList.remove("inactive")
							}
							idleState = false
							idleTimer = setTimeout(function () {
								const fooElement = document.querySelector(
									"#" +
										modal_id +
										" .product-media-modal__content"
								)
								fooElement.classList.add("inactive")
								idleState = true
							}, time)
						}
						showFoo(1000)

						window.addEventListener("mousemove", function (e) {
							showFoo(1000)
						})
					}, 500)
				}, 100)
			}

			showActiveMedia() {
				this.querySelectorAll(
					`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
						"data-media-id"
					)}"])`
				).forEach((element) => {
					element.classList.remove("active")
				})
				const activeMedia = this.querySelector(
					`[data-media-id="${this.openedBy.getAttribute(
						"data-media-id"
					)}"]`
				)
				const activeMediaTemplate =
					activeMedia.querySelector("template")
				const activeMediaContent = activeMediaTemplate
					? activeMediaTemplate.content
					: null
				activeMedia.classList.add("active")
				activeMedia.scrollIntoView()

				const container = this.querySelector('[role="document"]')
				container.scrollLeft =
					(activeMedia.width - container.clientWidth) / 2

				if (
					activeMedia.nodeName == "DEFERRED-MEDIA" &&
					activeMediaContent &&
					activeMediaContent.querySelector(".js-youtube")
				)
					activeMedia.loadContent()
			}
		}
	)
}
